var _circle, _rect, _circle2, _rect2, _circle3, _rect3, _circle4, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 386,
    viewBox: "0 0 18 386",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.80957,
    cy: 9.12891,
    r: 8.38086,
    fill: "#EFEFF3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.48828,
    y: 25.5098,
    width: 2.64258,
    height: 74.6533,
    fill: "#EFEFF3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.80957,
    cy: 116.544,
    r: 8.38086,
    fill: "#EFEFF3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.48828,
    y: 132.925,
    width: 2.64258,
    height: 74.6533,
    fill: "#EFEFF3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.80957,
    cy: 223.959,
    r: 8.38086,
    fill: "#EFEFF3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.48828,
    y: 240.34,
    width: 2.64258,
    height: 74.6533,
    fill: "#EFEFF3"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.80957,
    cy: 331.374,
    r: 8.38086,
    fill: "#EFEFF3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7.48828,
    y: 347.755,
    width: 2.64258,
    height: 37.5166,
    fill: "#EFEFF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepper);
export default __webpack_public_path__ + "static/media/stepper.666f14fe7dc83ec16750cb283dec89ea.svg";
export { ForwardRef as ReactComponent };